// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wizard {
  height: 100vh !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/Controls/Core/WizardBox.less"],"names":[],"mappings":"AAEA;EACE,wBAAA;AADF","sourcesContent":["\n@import '~common-controls/Style/Colors.less';\n.wizard {\n  height: 100vh !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
